<div class="row">
  @if (categories) {
    @for (category of categories; track category) {
      <div class="row list-row m-b-16">
        <div class="col-12 list-row-item" [class.col-md-4]="columns > 1">
          @if (categoryNameTranslate) {
            <span class="f-s-16">{{category[categoryLabel] | trans}}</span>
          }
          @if (!categoryNameTranslate) {
            <span class="f-s-16">{{category[categoryLabel]}}</span>
          }
        </div>
        <div class="col-12" [class.col-md-8]="columns > 1">
          <div class="row">
            @for (option of category[optionsIndex]; track option) {
              <div class="col-12" (click)="updateSelection(option)"
                [class.col-sm-12]="columns === 1"
                [class.col-sm-6]="columns === 2"
                [class.col-sm-4]="columns === 3">
                <div class="form-radio m-b-8">
                  <input class="form-check-input" type="radio" [value]="option[optionValue]" [(ngModel)]="selectedOption">
                  @if (optionLabelTranslate) {
                    <label class="form-check-label">{{option[optionLabel] | trans}}</label>
                  }
                  @if (!optionLabelTranslate) {
                    <label class="form-check-label">{{option[optionLabel]}}</label>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
  }
</div>
